import { Component, ViewChild, Input, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef } from '@angular/core';
import {
	ModalController,
	ViewWillEnter
} from '@ionic/angular';
import { CONSTANTS } from 'src/app/config/constants';
import { LocalStorage } from 'src/app/class/local-storage';
import { TypeOf } from 'src/app/enum/type-of';
import { StringHelper } from 'src/app/helper/string/string-helper';

@Component({
	selector: 'app-gallery',
	templateUrl: './gallery.component.html',
	styleUrls: ['./gallery.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class GalleryComponent implements ViewWillEnter {

	@ViewChild('swiper')
	public swiperRef: ElementRef | undefined;

	@Input()
	public images: Array<any> = [];
	@Input()
	public image: any;
	@Input()
	public title = 'Images';

	constructor(
		private modalController: ModalController,
		private changeDetectorRef: ChangeDetectorRef
	) { }

	public ionViewWillEnter() {
		let page = -1;
		for (
			let index = 0;
			this.images && index < this.images.length;
			index++
		) {
			const image = this.images[index];
			if (image.id && this.image.id && image.id === this.image.id) {
				page = index;
				break;
			}
		}
		if (page >= 0) {
			this.swiperRef?.nativeElement.swiper.slideTo(page);
			this.setTitle(page.toString());
		}
	}

	private setTitle(index: any) {
		if (!this.images || !this.images.length) {
			return;
		}
		const image = this.images[index];
		if (image && image.when) {
			if (image.when === 'before') {
				this.title = 'Before Photos';
			} else if (image.when === 'after') {
				this.title = 'After Photos';
			}
			this.changeDetectorRef.detectChanges();
		}
	}

	public slideDidChange(event: any) {
		let index = this.swiperRef?.nativeElement.swiper.activeIndex;
		this.setTitle(index);
	}

	public dismiss() {
		this.modalController.dismiss();
	}

	public imageCache(image: any) {

		if (image.base64String) {
			return StringHelper.sprintf('data:image/jpeg;base64,%s', image.base64String);
		}

		if ((typeof image.url === TypeOf.STRING || image.url instanceof String) && image.url.indexOf('http') >= 0) {
			return image.url + '?v=' + LocalStorage.get(CONSTANTS.localStorage.keys.imageCache);
		}

		return image.url;
	}
}
